import React from "react";
import { Tooltip } from "react-tooltip";

import "./button.scss";

interface IButtonProps {
  className?: string;
  title?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  pending?: boolean;
  tooltipMessage?: string;
  icon?: React.ReactNode;
  type?: "button" | "submit" | "reset";
  secondary?: boolean;
}

const Button: React.FC<IButtonProps> = ({
  className,
  title,
  onClick,
  disabled = false,
  pending = false,
  tooltipMessage,
  icon,
  type = "button",
  secondary = false,
}) => {
  const isDisabled = disabled || pending;
  const buttonClass = `button ${secondary ? "button--secondary" : ""} ${className || ""} ${isDisabled ? "button-disabled" : ""} ${pending ? "button-pending" : ""}`;

  const tooltipId = tooltipMessage ? `button-tooltip-${Math.random().toString(36).substr(2, 9)}` : undefined;

  return (
    <>
      <button
        type={type}
        className={buttonClass}
        onClick={onClick}
        disabled={isDisabled}
        data-tooltip-id={tooltipId}
        data-tooltip-content={tooltipMessage}
      >
        {icon}
        {pending ? <span className="button-spinner" /> : title}
      </button>

      {tooltipMessage && <Tooltip id={tooltipId} place="bottom" />}
    </>
  );
};

export default Button;
